import {
  HOLIDAY_FETCHING,
  HOLIDAY_FAILED,
  HOLIDAY_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case HOLIDAY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case HOLIDAY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case HOLIDAY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
